<template>
    <b-card 
        :title="translations.createSupplier[lang]" 
        @cancel="$emit('cancel')" 
        @submit="create()"
        :error-message="errorMessage"
        :disabled="!formValid"
        :loading="loading"
        :submit-text="{ el: 'Αποθήκευση', en: 'Save', it: 'Salva' }"
        :cancel-text="{ el: 'Ακύρωση', en: 'Cancel', it: 'Cancella' }"
    >
        <v-row no-gutters>
            <v-col cols="12" class="pr-2 d-flex justify-center">
                <h4 class="subtitle-2 mt-3 ml-2">{{ translations.supplier[lang] }}</h4>
            </v-col>

            <v-col cols="6" class="pr-2">
                <b-text-field 
                    :label="translations.user_full_name[lang]"
                    v-model="supplier.supplier_name"
                    :success="success.supplier_name"
                    :error-messages="error.supplier_name"
                    @focus="error.supplier_name = ''"
                    @blur="validateSupplierName"
                ></b-text-field>
            </v-col>
            <v-col cols="6" class="pr-2">
                
                <b-text-field 
                    type="number"
                    :label="translations.supplier_primary_phone[lang]"
                    v-model="supplier.supplier_primary_phone"
                    :success="success.supplier_primary_phone"
                    :error-messages="error.supplier_primary_phone"
                    @focus="error.supplier_primary_phone = ''"
                    @blur="validateSupplierPrimaryPhone"
                ></b-text-field>
            </v-col>

            <v-col cols="6" class="pr-2">
                <b-text-field 
                    :label="translations.supplier_email_1[lang]"
                    v-model="supplier.supplier_email_1"
                    :success="success.supplier_email_1"
                    :error-messages="error.supplier_email_1"
                    @focus="error.supplier_email_1 = ''"
                    @blur="validateSupplierEmail1"
                    type="email"
                ></b-text-field>
            </v-col>
            <v-col cols="6" class="pr-2">
                <b-text-field 
                    :label="translations.supplier_email_2[lang]"
                    v-model="supplier.supplier_email_2"
                    type="email"
                ></b-text-field>
            </v-col>

            <v-col cols="6" class="pr-2">
                <b-select
                    v-model="supplier.supplier_country_id"
                    :items="countries"
                    item-text="name"
                    item-value="country_id"
                    :label="translations.supplier_country[lang]"
                    :success="success.supplier_country"
                    :error-messages="error.supplier_country"
                    @focus="error.supplier_country = ''"
                    @blur="validateSupplierCountry"
                ></b-select>
            </v-col>

            <v-col cols="6" class="pr-2"></v-col>

            <v-col cols="12" class="pr-2 mt-2">
                <v-divider></v-divider>
            </v-col>
            
            <v-col cols="12" class="pr-2 d-flex justify-center mt-6">
                <h4 class="subtitle-2 mt-3 ml-2">{{ translations.supplierManager[lang] }}</h4>
            </v-col>

            <v-col cols="6" class="pr-2">
                <b-text-field 
                    :label="translations.user_full_name[lang]"
                    v-model="supplier.user_full_name"
                    :success="success.user_full_name"
                    :error-messages="error.user_full_name"
                    @focus="error.user_full_name = ''"
                    @blur="validateUserFullName"
                ></b-text-field>
            </v-col>
            <v-col cols="6" class="pr-2">
                <b-text-field
                    type="number"
                    :label="translations.user_mobile[lang]"
                    v-model="supplier.user_mobile"
                    :success="success.user_mobile"
                    :error-messages="error.user_mobile"
                    @focus="error.user_mobile = ''"
                    @blur="validateUserMobile"
                ></b-text-field>
            </v-col>

            <v-col cols="6" class="pr-2">
                <b-text-field 
                    :label="translations.user_email_1[lang]"
                    v-model="supplier.user_email_1"
                    type="email"
                ></b-text-field>
            </v-col>
            <v-col cols="6" class="pr-2">
                <b-text-field 
                    :label="translations.user_email_2[lang]"
                    v-model="supplier.user_email_2"
                    type="email"
                ></b-text-field>
            </v-col>

            <v-col cols="6" class="pr-2">
                <b-select
                    v-model="supplier.user_country_id"
                    :items="countries"
                    item-text="name"
                    item-value="country_id"
                    :label="translations.user_country[lang]"
                    :success="success.user_country"
                    :error-messages="error.user_country"
                    @focus="error.user_country = ''"
                    @blur="validateUserCountry"
                ></b-select>
            </v-col>
            <v-col cols="12" class="pr-2">
                <h4 class="subtitle-2 mt-3 ml-2">{{ translations.user_gender[lang] }}</h4>

                <v-radio-group
                    v-model="supplier.user_gender"
                    class="mt-3 pt-0" 
                    hide-details
                    :success="success.user_gender"
                    :error-messages="error.user_gender"
                    @focus="error.user_gender = ''"
                    @blur="validateUserGender"
                >
                    <v-row no-gutters>
                        <v-col class="ml-2" cols="auto" v-for="(gender,index) in genders" :key="index">
                            <v-radio color="secondary" :value="gender.value">
                                <template v-slot:label>
                                    <h4 class="subtitle-2">{{ translations[gender.text][lang] }}</h4>
                                </template>
                            </v-radio>
                        </v-col>
                    </v-row>
                </v-radio-group>
            </v-col>

        </v-row>
    </b-card>
</template>

<script>
import { mapMutations, mapState, mapActions } from "vuex";
import translations from "@/utils/translations/loyaltyPanel/supplierManagement";
import validators from "@/utils/validators/loyaltyPanel/supplierManagement";

export default {
    name: "CreateSupplier",

    mixins: [translations,validators],

    data: () => ({
        genders: [
            { 
                key: "male", 
                text: "male", 
                value: "male"
            },
            { 
                key: "female", 
                text: "female", 
                value: "female" 
            },
            { 
                key: "other",
                text: "other",
                value: "other"
            }
        ]
    }),

    computed: {
        ...mapState(["loading", "errorMessage"]),
        lang() {
            return this.$route.params.lang;
        },

        supplier: {
            get() {
                return this.$store.state.loyaltyPanel.supplierManagement.supplier;
            },
            set(val){
                this.setSupplier(val)
            }
        },

        countries() {
            return this.$store.state.loyaltyPanel.supplierManagement.countries
        },
    },
    methods: {
        ...mapMutations("loyaltyPanel/supplierManagement", ["setSupplier"]),
        ...mapActions("loyaltyPanel/supplierManagement", ["getCountries","create"]),
    },
    mounted(){
        this.getCountries()
    }
};
</script>

<style scoped></style>
